import { connect } from 'react-redux';

import FameSuccess from 'components/molecules/Fame/Success';
import { getAwardedSpecialBadges, getSpecialBadges } from 'store/mySuccess';

const mapStateToProps = (state) => ({
	badges: getSpecialBadges(state),
	awardedSpecialBadges: getAwardedSpecialBadges(state),
});

export default connect(mapStateToProps)(FameSuccess as any);
